import React, { useEffect, useState } from 'react'
import { Blacked, DBModalContent, DBModalInput, DBModalInputLine, DBModalInputWrap, ModalContent, ModalHeader, ModalInput, ModalSubmit, ModalTitle, ModalWrapper } from '../styles';
import { Icon } from 'CRM/organism/Main/styles';
import { FaChevronLeft } from 'react-icons/fa6';
import { Input, Select, message } from 'antd'
import { ChromePicker } from 'react-color';
import API from 'utils/api';
import { useToken } from 'app/hooks';
import { usePathList } from 'CRM/hooks/GetPathList';
import { useBranchList } from '../../../app/hooks/branchList';
import { useFilterList } from 'CRM/hooks/GetFilterList';
import { useEmployee } from 'CRM/hooks/GetEmployee';
import {useIsMobile} from "../IsMobile";

export const BranchPaydaEdit = ({ userId, setUserId, mutate }) => {
  const IsMobile = useIsMobile();
  const { data: token } = useToken();
  const { employee } = useEmployee(userId);
  const { data: paydaList } = useBranchList(true);
  const [paydaUser, setPaydaUser] = useState({email: '', usdAmount: '', name: '', ib: '', method: '', krwAmount: '', type: '', amount: '', date: ''});


  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [usdAmount, setUsdAmount] = useState('');
  const [ib, setIb] = useState('');
  const [method, setMethod] = useState('');
  const [krwAmount, setKrwAmount] = useState('');
  const [type, setType] = useState('');
  const [date, setDate] = useState('');

  useEffect(() => {

    setPaydaUser(paydaList?.find(it => it.id === userId))

  }, [userId])


  useEffect(() => {

    setName(paydaUser?.name || '');
    setEmail(paydaUser?.email || '');
    setUsdAmount(paydaUser?.usdAmount || '');
    setIb(paydaUser?.ib || '');
    setMethod(paydaUser?.method || '');
    setKrwAmount(paydaUser?.krwAmount || '');
    setType(paydaUser?.type || '');
    setDate(paydaUser?.date || '');

    mutate();
  }, [paydaList, mutate, paydaUser])

  const clickSubmit = () => {
    const shouldEdit = window.confirm(`내역을 수정하시겠습니까?`);
    if(shouldEdit) {
      if(name == '') {
        message.error('이름은 필수 입력입니다.')
      } else {
        API.put('/branch/list?id=' + userId, token + '', {
          datas: {
            name: name,
            email: email,
            usdAmount: usdAmount,
            ib: ib,
            method: method,
            krwAmount: krwAmount,
            type: type,
          }
        })
          .then((res: any) => {
            if (res.result.success) {
              message.success('수정되었습니다');
              mutate();
              setUserId(null);
            }
          })
          .catch((err: any) => {})
      }
    }
  }

  return (
    <>
      <Blacked onClick={() => setUserId(null)} />
      {IsMobile ?
        <ModalWrapper IsMobile={IsMobile}>
          <ModalHeader>
            <Icon onClick={() => setUserId(null)}><FaChevronLeft /></Icon>
            <ModalTitle>입출금 정보</ModalTitle>
            <ModalSubmit onClick={clickSubmit}>수정</ModalSubmit>
          </ModalHeader>
          <DBModalContent>
            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: 20}}>이메일</label>
                <DBModalInputWrap>
                  <Input type="text" value={email} onChange={(e) => setEmail(e.target.value)} placeholder='이메일을 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>

            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: 20}}>금액</label>
                <DBModalInputWrap>
                  <Input type="text" value={usdAmount} onChange={(e) => setUsdAmount(e.target.value)} placeholder='금액을 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>

            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: 20}}>이름</label>
                <DBModalInputWrap>
                  <Input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder='이름을 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>

            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: 20}}>IB</label>
                <DBModalInputWrap>
                  <Input type="text" value={ib} onChange={(e) => setIb(e.target.value)} placeholder='IB를 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>

            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: 20}}>거래수단</label>
                <DBModalInputWrap>
                  <Input type="text" value={method} onChange={(e) => setMethod(e.target.value)} placeholder='거래수단을 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>

            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: 20}}>원화</label>
                <DBModalInputWrap>
                  <Input type="text" value={krwAmount} onChange={(e) => setKrwAmount(e.target.value)} placeholder='원화 금액을 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>

            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: 20}}>입/출금</label>
                <DBModalInputWrap>
                  <Select value={type} onChange={(e) => setType(e)}>
                    {['입금', '출금'].map(it => (
                      <option style={{fontFamily: 'Pretendard'}} value={it === '입금' ? 1 : 2}>{it}</option>
                    ))}
                  </Select>
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>
          </DBModalContent>
        </ModalWrapper>
      :
        <ModalWrapper style={{minHeight: 300}}>
          <ModalHeader>
            <Icon onClick={() => setUserId(null)}><FaChevronLeft /></Icon>
            <ModalTitle>입출금 정보</ModalTitle>
            <ModalSubmit onClick={clickSubmit}>수정</ModalSubmit>
          </ModalHeader>
          <DBModalContent>
            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: 20}}>이메일</label>
                <DBModalInputWrap>
                  <Input type="text" value={email} onChange={(e) => setEmail(e.target.value)} placeholder='이메일을 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
              <DBModalInput>
                <label style={{padding: 20}}>금액</label>
                <DBModalInputWrap>
                  <Input type="text" value={usdAmount} onChange={(e) => setUsdAmount(e.target.value)} placeholder='금액을 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>
            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: 20}}>이름</label>
                <DBModalInputWrap>
                  <Input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder='이름을 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
              <DBModalInput>
                <label style={{padding: 20}}>IB</label>
                <DBModalInputWrap>
                  <Input type="text" value={ib} onChange={(e) => setIb(e.target.value)} placeholder='IB를 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>
            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: 20}}>거래수단</label>
                <DBModalInputWrap>
                  <Input type="text" value={method} onChange={(e) => setMethod(e.target.value)} placeholder='거래수단을 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
              <DBModalInput>
                <label style={{padding: 20}}>원화</label>
                <DBModalInputWrap>
                  <Input type="text" value={krwAmount} onChange={(e) => setKrwAmount(e.target.value)} placeholder='원화 금액을 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>

            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: 20}}>입/출금</label>
                <DBModalInputWrap>
                  <Select value={type} onChange={(e) => setType(e)}>
                    {['입금', '출금'].map(it => (
                      <option style={{fontFamily: 'Pretendard'}} value={it === '입금' ? 1 : 2}>{it}</option>
                    ))}
                  </Select>
                </DBModalInputWrap>
              </DBModalInput>
              {/*<DBModalInput>*/}
              {/*  <label style={{padding: 20}}>팀</label>*/}
              {/*  <DBModalInputWrap>*/}
              {/*    <Select value={team} onChange={(e) => setTeam(e)}>*/}
              {/*      {teamList?.map(it => (*/}
              {/*        <option style={{fontFamily: 'Pretendard'}} value={it.id}>{it.name}</option>*/}
              {/*      ))}*/}
              {/*    </Select>*/}
              {/*  </DBModalInputWrap>*/}
              {/*</DBModalInput>*/}
            </DBModalInputLine>
          </DBModalContent>
        </ModalWrapper>
      }

    </>
  )
}

export default React.memo(BranchPaydaEdit);